import React, { useState, useEffect } from "react";
import { useSwipeable } from 'react-swipeable';
// import SwipeableViews from 'react-swipeable-views';
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import TrippinPostGrid from "../components/TrippinPostGrid";
import PlaceGrid from "../components/PlaceGrid";
import BottomNav from "./BottomNav";
import { Tabs, Tab, CircularProgress } from "@mui/material";
import "../styles/saved.css"

function Saved() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const [savedTrippins, setSavedTrippins] = useState([]);
  const [savedPlaces, setSavedPlaces] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSavedItems = async () => {
      try {
        const [trippinsResponse, placesResponse] = await Promise.all([
          axiosInstance.get("/saved/trippins"), 
          axiosInstance.get("/saved/places"),
        ]);

        setSavedTrippins(trippinsResponse.data); 
        setSavedPlaces(placesResponse.data.savedPlaces || []);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching saved items:", err);
        setLoading(false);
      }
    };

    fetchSavedItems();
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // const handleSwipeChange = (index) => {
  //   setActiveTab(index);
  // };

  const handlers = useSwipeable({
    onSwipedLeft: () => setActiveTab((prev) => (prev < 1 ? prev + 1 : prev)),
    onSwipedRight: () => setActiveTab((prev) => (prev > 0 ? prev - 1 : prev)),
    trackMouse: true,
  });

  if (loading) {
    return  (
      <>
        <div className="loading-container">
          <CircularProgress size={40} sx={{ color: 'black' }} />
        </div>
        <BottomNav />
      </>
    );
  }

  return (
    <div {...handlers} className="saved-container">
      <Tabs 
        value={activeTab} 
        onChange={handleTabChange} 
        centered 
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#2c3e50",
          },
          "& .MuiTab-root": {
            fontFamily: "'Poppins', sans-serif",
            color: "#555",
          },
          "& .MuiTab-root.Mui-selected": {
            color: "#2c3e50",
            fontWeight: "bold",
          },
        }}
      >
        <Tab label="Saved Trippins" />
        <Tab label="Saved Places" />
      </Tabs>

      {activeTab === 0 && (
        <div className="trippin-grid">
          <TrippinPostGrid
            posts={savedTrippins}
            navigate={navigate}
            isProfile={true}
          />
        </div>
      )}

      {activeTab === 1 && (
        <div className="place-grid">
          <PlaceGrid
            places={savedPlaces}
            navigate={navigate}
          />
        </div>
      )}
      
      <BottomNav />
    </div>
  );
}

export default Saved;